import Icon from "../Icon";
import MenuMas from "../widgets/MenuMas";
import { NotionLogo } from "../widgets/NotionOrigen";
import ChipPrioridad from "./ChipPrioridad";
import PlanificarMenu from "./PlanificarMenu";
import { textoVencimiento, proximoLunes, manana } from "./fechas";
import { textoRecordatorio, etiquetaDia } from "./planes";

const ESTADO_TEXTO = { en_curso: "En curso" };

// Una tarea: «Hecha» (boton con texto, lejos del resto para no pulsarlo por error), «Planificar»
// (cuando hay vista Plan) y todo lo demas en «Más».
// La prioridad va en texto (ChipPrioridad), el estado y «Bloqueada» tambien: el color
// nunca es lo unico que dice algo. El icono de flujo indica el origen (paso de proyecto).
export default function FilaTarea({ tarea: t, onHecha, onAccion, onAbrirProyecto, hoy, conPlan = false, conteo, tope,
  onPlan, onPlanRapido, onRecordatorio, onQuitarRecordatorio, onConectarMicrosoft, onNoPuedo, onHilo, onMantener }) {
  const venc = textoVencimiento(t.fecha, hoy);
  const enHoy = t.estado_personal === "hoy";
  const aplazada = t.estado_personal === "aplazada";
  const esNotion = t.origen === "notion";
  const esEncargo = t.origen === "encargo";
  const proyecto = t.proyecto?.nombre || (esNotion ? "Notion" : esEncargo ? "Tarea enviada" : "Sin proyecto");

  const acciones = [
    // Con la vista Plan, «hoy» se decide en «Planificar»; sin ella, se fija desde aqui.
    ...(conPlan ? [] : [{ clave: "dia", etiqueta: enHoy ? "Quitar de hoy" : "Fijar para hoy", icono: "sun",
      onClick: () => onAccion(t, { estado: enHoy ? "pendiente" : "hoy" }) }]),
    // La fecha va en la etiqueta: «mañana» no dice a que dia se va.
    { clave: "manana", etiqueta: `Aplazar a mañana, ${etiquetaDia(manana(hoy)).toLowerCase()}`, icono: "clock",
      onClick: () => onAccion(t, { estado: "aplazada", aplazada_hasta: manana(hoy) }) },
    // Con la vista Plan, «a la semana siguiente» NO oculta la tarea: la pone en un grupo visible y despues se
    // elige el dia. Sin ella («Aplazar al lunes» oculta hasta el lunes, y si hoy es lunes son siete dias).
    conPlan && onPlanRapido
      ? { clave: "semana-siguiente", etiqueta: "A la semana siguiente", icono: "clock",
          onClick: () => onPlanRapido(t, { tipo: "semana_siguiente" }) }
      : { clave: "lunes", etiqueta: "Aplazar al lunes", icono: "clock",
          onClick: () => onAccion(t, { estado: "aplazada", aplazada_hasta: proximoLunes(hoy) }) },
    ...(t.proyecto?.id ? [{ clave: "abrir", etiqueta: "Abrir en el proyecto", icono: "box-arrow-up-right",
      onClick: () => onAbrirProyecto?.(t.proyecto) }] : []),
    ...(esNotion && t.url && !t.no_disponible ? [{ clave: "notion", etiqueta: "Abrir en Notion", icono: "box-arrow-up-right",
      onClick: () => window.open(t.url, "_blank", "noopener,noreferrer") }] : []),
    // Una tarea enviada no se descarta: se contesta «No puedo» con un motivo que lee quien la mando
    ...(esEncargo ? [
      ...(onHilo ? [{ clave: "hilo", etiqueta: "Ver conversación", icono: "journal-text", onClick: () => onHilo(t) }] : []),
      ...(onNoPuedo ? [{ clave: "nopuedo", etiqueta: "No puedo hacerla", icono: "x", onClick: () => onNoPuedo(t) }] : []),
    ] : [{ clave: "descartar", etiqueta: "Descartar", icono: "trash3",
      onClick: () => onAccion(t, { estado: "descartada" }) }]),
  ];

  return (
    <div className={"mt-fila" + (t.bloqueada ? " bloq" : "")}>
      <div className="mt-cuerpo">
        <div className="mt-titulo">{t.titulo}{t.no_disponible && " (no disponible)"}</div>
        {esEncargo && t.encargo?.descripcion && <div className="mt-desc">{t.encargo.descripcion}</div>}
        <div className="mt-meta">
          {esEncargo && t.enviada_por && (
            <span className="mt-enviada"><Icon name="person" size={10} color="currentColor" />Enviada por {t.enviada_por.nombre}</span>
          )}
          {(!esEncargo || t.proyecto?.nombre) && (
            <span className="mt-proyecto" title={esNotion ? "Página de Notion" : `Paso del proyecto ${proyecto}`}>
              {esNotion ? <NotionLogo title="Página de Notion" /> : <Icon name="diagram-3" size={11} color="currentColor" />}
              <span>{t.no_disponible ? "Notion · la página ya no existe" : esNotion && t.proyecto?.nombre ? `${proyecto} · Notion` : proyecto}</span>
            </span>
          )}
          <span className={"mt-venc " + venc.tono}>
            {aplazada && t.aplazada_hasta ? `Aplazada hasta ${textoVencimiento(t.aplazada_hasta, hoy).texto.toLowerCase()}` : venc.texto}
          </span>
          {/* La prioridad solo se dice cuando se sale de lo normal (Media): en cada fila, siempre, era ruido */}
          {t.prioridad !== 1 && <ChipPrioridad prioridad={t.prioridad} />}
          {ESTADO_TEXTO[t.estado] && <span className="mt-estado">{ESTADO_TEXTO[t.estado]}</span>}
          {t.bloqueada && (
            <span className="mt-bloq"><Icon name="lock-fill" size={10} color="currentColor" />Bloqueada</span>
          )}
          {esEncargo && t.encargo?.mensajes_total > 0 && onHilo && (
            <button type="button" className="mt-coment btn" onClick={() => onHilo(t)}
              aria-label={`Ver la conversación: ${t.titulo}, ${t.encargo.mensajes_total} comentarios`} title="Ver la conversación">
              <Icon name="chat-dots-fill" size={12} color="currentColor" /> {t.encargo.mensajes_total}</button>
          )}
          {t.ya_no_es_mia && <span className="mt-reasig"><span aria-hidden="true">!</span>Ya no es tuya en Notion</span>}
          {t.plan?.caducado && <span className="mt-estado" title="Estaba planificada para una semana anterior">Vuelve a Sin planificar</span>}
          {t.recordatorio && (
            <span className="mt-todo" title={`Recordatorio en Microsoft To Do: ${textoRecordatorio(t.recordatorio)}`}>
              <Icon name="list-check" size={11} color="currentColor" />
              <span className="sr-only">Recordatorio en To Do: </span>
              <span>{textoRecordatorio(t.recordatorio)}</span>
              {onQuitarRecordatorio && (
                <button type="button" className="mt-todo-q" onClick={() => onQuitarRecordatorio(t)}
                  aria-label={`Quitar el recordatorio de To Do: ${t.titulo}`}>Quitar</button>
              )}
            </span>
          )}
        </div>
        {t.ya_no_es_mia && (
          <div className="mt-reasig-n">
            <span>Alguien la ha reasignado en Notion. La conservamos: no borramos nada que hayas planificado, hecho o aplazado.</span>
            <span className="mt-reasig-b">
              {onMantener && <button type="button" className="mt-b btn" onClick={() => onMantener(t)} aria-label={`Conservar: ${t.titulo}`}>Conservar</button>}
              <button type="button" className="mt-b nv-no btn" onClick={() => onAccion(t, { estado: "descartada" })} aria-label={`Quitar de mis tareas: ${t.titulo}`}>Quitar de mis tareas</button>
            </span>
          </div>
        )}
      </div>
      <div className="mt-acc">
        {conPlan && <PlanificarMenu tarea={t} conteo={conteo} tope={tope} hoy={hoy} onPlan={onPlan}
          onRecordatorio={onRecordatorio} onConectarMicrosoft={onConectarMicrosoft} />}
        <button type="button" className="mt-hecha-b btn" onClick={() => onHecha(t)}
          aria-label={`Marcar como hecha: ${t.titulo}`}>
          <Icon name="check2" size={14} color="currentColor" /><span>Hecha</span>
        </button>
        <MenuMas acciones={acciones} soloIcono etiqueta={`Más acciones: ${t.titulo}`} />
      </div>
    </div>
  );
}
